export default __webpack_public_path__ + "static/media/onspring.b61c947a.svg";